export default __webpack_public_path__ + "static/media/webmoney_avatar.a1942ca9.svg";